import React from 'react';
import DocumentTitle from 'react-document-title';

function Index() {
    return (
        <DocumentTitle title="小青账-第三方信息共享清单">
            <div className="home-page">
                <div className="home-page-wrapper">
                    <h1>第三方信息共享清单</h1>
                    <br/>
                    <p>为了保障我们客户端的稳定运行、功能实现，使您能够使用和享受更多的服务及功能，我们的应用中会嵌入授权合作伙伴的SDK或其他应用程序。此时，第三方SDK服务商可能会收集您的相关信息。</p>
                    <p>当你使用第三方提供的服务时，我们会在获得或确保第三方获得你的授权同意后。以及其他符合法律法规规定的情形下共享对应信息。你可以通过本清单中列举的相关信息了解第三方会如何处理你的个人信息。我们也会对第三方获取个人信息的行为进行严格约束以保护你的个人信息安全。</p>
                    <p>具体第三方SDK的使用情况如下：</p>
                    <br/>
                    <h3><strong>SDK名称：</strong> <strong>微信 SKD</strong></h3>
                    <p><strong>开发者名称：</strong><a href="https://open.weixin.qq.com/">深圳市腾讯计算机系统有限公司</a></p>
                    <p><strong>收集信息范围：</strong>本机应用列表、设备型号、设备序列号、操作系统、设备Mac地址、
                        唯一设备识别码（IMEI/android ID/IDFA/OPENUDID/GUID、SIM 卡 IMSI 信息）、
                        登录IP地址、微信软件版本号、接入网络的方式、类型和状态、网络质量数据、操作日志
                    </p>
                    <p><strong>使用场景：</strong>为了提供微信支付以及微信分享和微信授权登录功能</p>
                    <p><strong>使用目的：</strong>支持微信登录、分享、支付服务</p>
                    <p><strong>共享方式：</strong>SDK本机采集</p>
                    <p><strong>隐私政策链接：</strong><a href="https://privacy.qq.com">https://privacy.qq.com</a></p>
                    <br/>
                    <h3><strong>SDK名称：</strong> <strong>支付宝 SDK</strong></h3>
                    <p><strong>开发者名称：</strong><a href="https://www.alipay.com/">支付宝（中国）网络技术有限公司</a></p>
                    <p><strong>收集信息范围：</strong>常用设备信息（IMEI/IMSI、SIM卡序列号/MAC地址、Android
                        ID、OAID、AAID、SSID、BSSID；系统设置、系统属性、设备型号、设备品牌、操作系统；IP 地址、网络类型、运营商信息、Wi-Fi
                        状态、Wi-Fi 参数、Wi-Fi 列表）、
                        以及地理位置信息、可变更设备唯一标识、软件安装列表</p>
                    <p><strong>使用场景：</strong>用户下单后支付环节、支付宝公司为了保障您的账户和资金安全以及支付服务的安全稳定运行</p>
                    <p><strong>使用目的：</strong>帮助用户在应用内使用支付宝</p>
                    <p><strong>共享方式：</strong>SDK本机采集</p>
                    <p><strong>隐私政策链接：</strong><a
                        href="https://opendocs.alipay.com/open/54">https://opendocs.alipay.com/open/54</a></p>
                    <br/>
                    <h3><strong>SDK名称：</strong> <strong>360加固SDK</strong></h3>
                    <p><strong>开发者名称：</strong><a href="https://jiagu.360.cn">北京三六零智领科技有限公司</a></p>
                    <p><strong>收集信息范围：</strong>设备基础信息（Android ID、OAID，网络类型、系统运行语言环境、操作系统版本名称、操作系统版本、机型、系统版本、厂商、终端主板名称、品牌、设备内存大小、手机屏幕分辨率、运行环境），网络信息，安全信息</p>
                    <p><strong>使用场景：</strong>启动App</p>
                    <p><strong>使用目的：</strong>用于检测App故障和诊断,App安全加固保护,盗版检测服务,威胁环境检测服务,以便帮助用户快速解决异常情况</p>
                    <p><strong>共享方式：</strong>SDK本机采集</p>
                    <p><strong>隐私政策链接：</strong><a
                        href="https://jiagu.360.cn/#/global/help/322">https://jiagu.360.cn/#/global/help/322</a></p>
                </div>
            </div>
        </DocumentTitle>
    );
}

export default Index;
